module.exports = __webpack_public_path__ + "media/src/images/top_covers/2021_jan_01-0cb3a6e62dec8faaf5f5a51975f6227c.png";